var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxoutlineoriginSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9,6.6H5.5C5,6.6,4.7,6.3,4.7,5.9V2.1c0-0.4,0.3-0.8,0.8-0.8h16.5c0.4,0,0.8,0.3,0.8,0.8v3.8 C22.7,6.3,22.4,6.6,21.9,6.6z M6.2,5.1h15V2.8h-15V5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7,18c-0.4,0-0.8-0.3-0.8-0.8V6c0-0.4,0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8v11.2C20.4,17.6,20.1,18,19.7,18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7,22.7c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S21.4,22.7,19.7,22.7z M19.7,18.2c-0.8,0-1.5,0.7-1.5,1.5 s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S20.5,18.2,19.7,18.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7,18c-0.4,0-0.8-0.3-0.8-0.8V6c0-0.4,0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8v11.2C14.4,17.6,14.1,18,13.7,18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7,22.7c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S15.3,22.7,13.7,22.7z M13.7,18.2c-0.8,0-1.5,0.7-1.5,1.5 s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S14.5,18.2,13.7,18.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,17.4c-0.1,0-0.1,0-0.2,0c-0.4-0.1-0.6-0.5-0.5-0.9L7,5.9c0.1-0.4,0.5-0.6,0.9-0.5 c0.4,0.1,0.6,0.5,0.5,0.9L5.7,16.9C5.6,17.2,5.3,17.4,5,17.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.3,22.1c-0.2,0-0.5,0-0.8-0.1c-0.8-0.2-1.4-0.7-1.8-1.4c-0.4-0.7-0.5-1.5-0.3-2.3c0.4-1.6,2.1-2.6,3.7-2.1 c0.8,0.2,1.4,0.7,1.8,1.4s0.5,1.5,0.3,2.3C6.9,21.2,5.7,22.1,4.3,22.1z M4.3,17.6c-0.7,0-1.3,0.4-1.5,1.1c-0.1,0.4,0,0.8,0.2,1.1 s0.5,0.6,0.9,0.7c0.8,0.2,1.6-0.3,1.8-1.1c0.1-0.4,0-0.8-0.2-1.1s-0.5-0.6-0.9-0.7C4.6,17.6,4.5,17.6,4.3,17.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxoutlineoriginSearch);
export default __webpack_public_path__ + "static/media/vuesaxoutlineorigin-search.78a71e581b75d83c1016712ab02330c2.svg";
export { ForwardRef as ReactComponent };